import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";
import FilteredCourses from "components/course-areas/FilteredCourses";

class AllCourses extends Component {
  render() {
    return (
      <>
        <div className="flex-space-between padding-top padding-sides padding-bottom">
          <h1>All courses</h1>
          <NavLink to="/course-areas">
            <MasterButton type={BUTTON_TYPES.TERTIARY} text="Back" />
          </NavLink>
        </div>
        <FilteredCourses />
      </>
    );
  }
}

export default AllCourses;
